import { useState } from "react"
import { Box, Button, DialogActions, DialogContent, DialogTitle, Stack, TextField } from "@mui/material"
import { setFromEvent } from "lib/setFromEvent"

export function ConfirmDialogWithSavedInput({
    title,
    message,
    label,
    ok,
    cancel,
    buttons,
    dataCy = "confirm-input",
    confirmProp = "confirmValue",
}) {
    const [value, setValue] = useState("")

    return (
        <>
            {title && <DialogTitle>{title}</DialogTitle>}
            <DialogContent data-cy="confirm-dialog-content" sx={{ mt: 2 }}>
                <Stack spacing={2}>
                    <Box>{message}</Box>
                    <TextField
                        fullWidth
                        multiline
                        minRows={2}
                        label={label}
                        value={value}
                        onChange={setFromEvent(setValue)}
                        data-cy={dataCy}
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={cancel} color="secondary">
                    Cancel
                </Button>
                {buttons ? (
                    buttons.map((b) => (
                        <Button key={b} onClick={() => ok(b)} color="primary">
                            {b}
                        </Button>
                    ))
                ) : (
                    <Button
                        onClick={() => ok({ [confirmProp]: value || undefined })}
                        color="primary"
                        variant="contained"
                        id="confirmOkButton"
                        data-cy="dialogActionsOkButton"
                    >
                        Ok
                    </Button>
                )}
            </DialogActions>
        </>
    )
}
